import React, { useState, useEffect } from 'react';
import { getImeiList, getDataCheck, getVariableNames } from '../api';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import './AdminDataCheck.css';

const AdminDataCheck = () => {
  const [imeiList, setImeiList] = useState([]);
  const [imei, setImei] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [param, setParam] = useState('');
  const [paramOptions, setParamOptions] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Загрузка списка IMEI при монтировании
  useEffect(() => {
    const fetchImeiList = async () => {
      try {
        const list = await getImeiList();
        setImeiList(list);
      } catch (err) {
        console.error('Ошибка загрузки IMEI:', err);
      }
    };
    fetchImeiList();
  }, []);

  // При смене IMEI загружаем доступные параметры
  useEffect(() => {
    const fetchParams = async () => {
      if (!imei) {
        setParamOptions([]);
        return;
      }
      try {
        const names = await getVariableNames(imei);
        setParamOptions(names);
      } catch (err) {
        console.error('Ошибка загрузки параметров:', err);
        setParamOptions([]);
      }
    };
    fetchParams();
  }, [imei]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!imei || !startDate || !endDate || !param) {
      setError('Заполните все поля');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const result = await getDataCheck(imei, startDate, endDate, param);
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Форматирование даты для отображения
  const formatDate = (timestamp) => {
    const d = new Date(timestamp);
    return d.toLocaleString();
  };

  return (
    <div className="admin-data-check">
      <h2>Проверка данных</h2>
      <div className="filter-section">
        <form onSubmit={handleSubmit} className="filter-form">
          <div className="form-group">
            <label>IMEI</label>
            <input
              list="imei-list"
              value={imei}
              onChange={(e) => setImei(e.target.value)}
              placeholder="Введите или выберите IMEI"
              required
            />
            <datalist id="imei-list">
              {imeiList.map((imeiItem) => (
                <option key={imeiItem} value={imeiItem} />
              ))}
            </datalist>
          </div>

          <div className="form-group">
            <label>Начало периода</label>
            <input
              type="datetime-local"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Конец периода</label>
            <input
              type="datetime-local"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Параметр</label>
            <select
              value={param}
              onChange={(e) => setParam(e.target.value)}
              required
            >
              <option value="">Выберите параметр</option>
              {paramOptions.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Загрузка...' : 'Показать'}
          </button>
        </form>
      </div>

      {error && <div className="error-message">{error}</div>}

      {data.length > 0 && (
        <>
          <div className="chart-section">
            <h3>График значений</h3>
            <ResponsiveContainer width="100%" height={400}>
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="timestamp"
                  tickFormatter={(ts) => new Date(ts).toLocaleString()}
                  interval="preserveStartEnd"
                  tickCount={10}
                />
                <YAxis />
                <Tooltip
                  labelFormatter={(label) => new Date(label).toLocaleString()}
                  formatter={(value) => [value, 'Значение']}
                />
                <Line type="monotone" dataKey="value" stroke="#8884d8" dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>

          <div className="table-section">
            <h3>Таблица значений</h3>
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Дата и время</th>
                    <th>Значение</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => (
                    <tr key={idx}>
                      <td>{formatDate(item.timestamp)}</td>
                      <td>{item.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      {data.length === 0 && !loading && !error && (
        <div className="no-data">Нет данных за выбранный период</div>
      )}
    </div>
  );
};

export default AdminDataCheck;